export default function InvoicesIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M381.74,104.59v273.73l-43.96-26.1-43.96,38.46-43.95-38.46-43.96,38.46-43.96-38.46-43.69,26.1V104.59h263.48M381.74,77H103.91c-7.31,0-13.24,5.93-13.24,13.24v313.37c0,10.28,11.21,16.64,20.04,11.37l21.71-12.97,26.46-15.81,28.86,25.25,9.45,8.27c4.99,4.37,12.45,4.37,17.44,0l9.45-8.27,25.79-22.56,25.78,22.56,9.45,8.27c4.99,4.37,12.45,4.37,17.44,0l9.45-8.27,28.91-25.29,26.76,15.89,21.67,12.87c8.83,5.24,20.01-1.12,20.01-11.39V90.24c0-7.31-5.93-13.24-13.24-13.24h-14.35Z" />
      <rect x="160.6" y="148.74" width="177.7" height="27.59" rx="5.52" ry="5.52" />
      <rect x="160.6" y="212.76" width="177.7" height="27.59" rx="5.52" ry="5.52" />
      <rect x="264.35" y="276.77" width="73.95" height="27.59" rx="5.52" ry="5.52" />
    </svg>
  );
}
